import { ExecutionContext, html, ref, repeat } from '@genesislcap/web-core';
import { DealsRoute } from './deals';
import { customEvent } from '@genesislcap/foundation-events';
import {DetailViewDeal} from '../../../../pbi/components/deals/deals.types';

export const MAX_DETAIL_TABS = 10;

export const dealsTemplate = html<DealsRoute>`
  <rapid-tabs ${ref('tabs')} activeid="${(x) => x.activeTabId}" @change="${(x) => x.handleTabChange()}">
    <rapid-tab id="default" class="${(x) => x.activeTabId === 'default' ? 'deals-tab-active' : ''}">Deals</rapid-tab>
    ${repeat(x => x.detailViewDeals, html<DetailViewDeal>`
      <rapid-tab
        id="${x => String(x.DEAL_ID)}"
        class="${(x, ctx: ExecutionContext<DealsRoute>) => ctx.parent.getDetailTabClass(x, ctx.parent.activeTabId, ctx.parent.reconfirmEligibilityMap)}"
      >
        <div class="deal-tab-description">Deal | ${x => x.DEAL_DESCRIPTION}</div>
        <rapid-icon size="l" @click="${(x, ctx: ExecutionContext<DealsRoute>) => ctx.parent.closeDetailView(customEvent(ctx), x)}" name="xmark"></rapid-icon>
      </rapid-tab>
    `)}
    <rapid-tab-panel>
      <muni-deals
        :openDetailViewDealIds="${(x) => x.detailViewDeals.map((d) => d.DEAL_ID)}"
        @dealClicked="${(x, ctx) => x.handleRowClick(customEvent(ctx))}"
        @deal-updated-from-listing="${(x, ctx) => x.handleDealUpdatedFromListing(customEvent(ctx))}"
      ></muni-deals>
    </rapid-tab-panel>
    ${repeat(x => x.detailViewDeals, html<DetailViewDeal>`
      <rapid-tab-panel>
        <deal-detail
          :deal="${x => x}"
          @reconfirm-eligibility-changed="${(x, ctx: ExecutionContext<DealsRoute>) => ctx.parent.handleReconfirmEligibilityChanged(customEvent(ctx))}"
        ></deal-detail>
      </rapid-tab-panel>
    `)}
  </rapid-tabs>
  <rapid-modal ${ref('maxTabsModal')}>
    <h3 slot="top">Maximum ${MAX_DETAIL_TABS} deals open at once</h3>
    <p>Please close one in order to open another</p>
    <div class="active-deals">
      ${repeat(x => x.detailViewDeals, html<DetailViewDeal>`
        <div class="active-deals-item">
          <div class="active-deals-item-description">
            ${x => x.DEAL_DESCRIPTION}
          </div>
          <div class="active-deals-item-close" @click="${(x, ctx: ExecutionContext<DealsRoute>) => ctx.parent.removeDetailViewBeforeAdding(x)}">
            <rapid-icon name="xmark" size="xl"></rapid-icon>
          </div>
        </div>
      `)}
    </div>
    <div slot="bottom">
      <rapid-button @click="${x => x.cancelClose()}">Cancel</rapid-button>
      <rapid-button @click="${x => x.closeAllDeals()}" appearance="primary">Close All</rapid-button>
    </div>
  </rapid-modal>
`
